<template>
    <th>
        <v-btn :text="props.title" class="text-capitalize pa-0" variant="text" @click="sort">
            <template v-if="sortable && clickCount && column === sortedColumn" v-slot:append>
                <v-icon :icon="order==='asc'?'mdi-menu-down':'mdi-menu-up'"></v-icon>
            </template>
        </v-btn>
    </th>
</template>
<script setup>
import {ref} from "vue";

const emits = defineEmits(['sort']);
const props = defineProps({
    title: {
        type: String,
        default: null
    },
    color: {
        type: String,
        default: null
    },
    sortable: {
        type: Boolean,
        default: false
    },
    column: {
        type: String,
    },
    sortedColumn: {
        type: String,
    }
});

const order = ref('asc');
const clickCount = ref(0);
const sort = () => {
    if (!props.sortable) {
        return;
    }
    clickCount.value++;
    switch (clickCount.value) {
        case 1:
            order.value = 'asc';
            emits('sort', {column: props.column, order: order.value});
            break;
        case 2:
            order.value = 'desc';
            emits('sort', {column: props.column, order: order.value});
            break;
        default:
            order.value = null;
            clickCount.value = 0;
            emits('sort', {column: null, order: null});
    }
}
</script>
